// extracted by mini-css-extract-plugin
export default {"form":"CandidateReference_form__XgbTz"};